import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Slider from "rc-slider";
import "./rateSlider.css";

const BankruptcySlider = (props: {
  onChange?: (e: number) => void;
  value?: number;
}) => {
  const [value, setValue] = useState<number>(2);

  useEffect(() => {
    if (props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  useEffect(() => {
    if (props.onChange) props.onChange(value);
  }, [value, props]);

  const handleChange = (e: number) => {
    setValue(e);
  };

  return (
    <div>
      <Form.Group controlId="formBasicRange">
        <h2 className="rate-slider-header">
          {value === 1
            ? "Last 12 Months"
            : value === 6
            ? "6+ Years"
            : value + " Years"}
        </h2>
        <Slider
          min={1}
          max={6}
          step={1}
          value={value}
          defaultValue={value}
          onChange={(e) => {
            handleChange(e);
          }}
        />
      </Form.Group>
    </div>
  );
};

export default BankruptcySlider;
